module.exports = __webpack_public_path__ + "img/announcementImg.35b92762.svg";